/**
 * The couple's photograph on the weddings grid.
 *
 * Separate from the message-image limits in `body.ts` because the two are
 * bounded by different things. A message image is bounded by what a vendor's
 * mail server will accept on an assembled RFC 822 message; this one never
 * leaves the planner's own browser, and is bounded by what a 4-across grid of
 * circles can actually show. 900px is roughly double the widest a tile renders
 * at on a large display, which covers retina without storing a wall poster.
 */

/** Longest edge after the browser re-encodes. */
export const WEDDING_PHOTO_MAX_EDGE = 900;

/** What the browser re-encodes toward. */
export const WEDDING_PHOTO_TARGET_BYTES = 200 * 1024;

/**
 * Server-side backstop, on what arrives after the browser has already resized.
 *
 * Generous relative to the target because the resize is a courtesy, not a
 * guarantee: an animated GIF is passed through untouched, and a photograph of
 * noise does not compress. The number that matters for storage cost is the
 * target above; this one exists so a client that skips the resize entirely
 * cannot put a 12MB phone original in the bucket.
 */
export const WEDDING_PHOTO_MAX_BYTES = 2 * 1024 * 1024;
